import {
    invoiceDetailRequestFailed,
    invoiceDetailRequestStarted, invoiceDetailRequestSuccess,
    invoiceListRequestFailed,
    invoiceListRequestStarted,
    invoiceListRequestSuccess, invoiceSettingRequestFailed, invoiceSettingRequestStarted, invoiceSettingRequestSuccess,
} from "./InvoiceListViewActions";
import * as api from '../Api'
import ConsoleHelper from "../../helpers/ConsoleHelper";

export const retrieveInvoicesForToday = (type) => {
    return (dispatch) => {
        dispatch(invoiceListRequestStarted());
        api.retrieveInvoicesForToday(type)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(invoiceListRequestSuccess(resp.data.data))
                } else {
                    dispatch(invoiceListRequestFailed(resp.data.message))
                }
            })
            .catch(error => {
                ConsoleHelper(error.message);
                // dispatch(invoiceListRequestFailed(error.message))
            })
    }
}

export const searchByInvoiceNumber = (type, invoiceNumber) => {
    return (dispatch) => {
        dispatch(invoiceListRequestStarted());
        api.searchInvoicesByInvoiceNumber(type, invoiceNumber)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(invoiceListRequestSuccess(resp.data.data))
                } else {
                    dispatch(invoiceListRequestFailed(resp.data.message))
                }
            })
            .catch(error => {
                dispatch(invoiceListRequestFailed(error.message))
            })
    }
}

export const listInvoicesByCustomerCode = (type, startDate, endDate, customerCode) => {
    return (dispatch) => {
        dispatch(invoiceListRequestStarted());
        api.searchInvoicesByCustomerCode(type, startDate, endDate, customerCode)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(invoiceListRequestSuccess(resp.data.data))
                } else {
                    dispatch(invoiceListRequestFailed(resp.data.message))
                }
            })
            .catch(error => {
                dispatch(invoiceListRequestFailed(error.message))
            })
    }
}

export const listInvoicesByCustomerName = (type, startDate, endDate, customerName) => {
    return (dispatch) => {
        dispatch(invoiceListRequestStarted());
        api.searchInvoicesByCustomerName(type, startDate, endDate, customerName)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(invoiceListRequestSuccess(resp.data.data))
                } else {
                    dispatch(invoiceListRequestFailed(resp.data.message))
                }
            })
            .catch(error => {
                dispatch(invoiceListRequestFailed(error.message))
            })
    }
}
export const searchInvoiceByCustomerOrderNumber = (type,   customerName) => {
    return (dispatch) => {
        dispatch(invoiceListRequestStarted());
        api.searchInvoicesByCustomerOrderNumber(type,   customerName)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(invoiceListRequestSuccess(resp.data.data))
                } else {
                    dispatch(invoiceListRequestFailed(resp.data.message))
                }
            })
            .catch(error => {
                dispatch(invoiceListRequestFailed(error.message))
            })
    }
}

export const getInvoiceDetailLines = (source, invoiceNumber) => {
    return (dispatch) => {
        dispatch(invoiceDetailRequestStarted());
        api.getInvoiceDetailLines(source, invoiceNumber)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(invoiceDetailRequestSuccess(resp.data.data))
                } else {
                    dispatch(invoiceDetailRequestFailed(resp.data.message))
                }
            })
            .catch(error => {
                dispatch(invoiceDetailRequestFailed(error.message))
            })
    }
}

export const retrieveInvoiceSetting= () =>{
    return (dispatch) => {
        dispatch(invoiceSettingRequestStarted());
        api.retrieveInvoiceSetting()
            .then(resp => {
                if (resp.data.success) {
                    ConsoleHelper(resp.data.data)
                    dispatch(invoiceSettingRequestSuccess(resp.data.data))
                } else {
                    dispatch(invoiceSettingRequestFailed(resp.data.message))
                }
            })
            .catch(error => {
                dispatch(invoiceSettingRequestFailed(error.message))
            })
    }
}

